import Swal from 'sweetalert2';

export function customSwal ({
    title,
    text,
    icon = 'info',
    confirmButtonText = 'Submit',
    confirmButtonColor = '#FB8C00',
    showDenyButton = false,
    showCancelButton = false,
    denyButtonText = '',
    denyButtonColor = '#ff3e1d',
    showLoaderOnConfirm = false,
    preConfirmFn = null,
    timer = null,
}) {
    const swal = Swal.fire({
        title,
        text,
        icon,
        showDenyButton,
        showCancelButton,
        confirmButtonText,
        confirmButtonColor,
        denyButtonText,
        denyButtonColor,
        showLoaderOnConfirm,
        preConfirm: preConfirmFn,
        allowOutsideClick: () => !Swal.isLoading()
    });

    return swal;
};